// lovingly stolen from:
/**
 * Emitter - broadcasts app-level events and important changes
 * @module emitter
 * @copyright Trinity Mirror 2016
 * @author Stuart Campbell (stuart.campbell@trinitymirror.com)
 */

import events from "@trinitymirrordigital/chameleon-core/src/js/events.js";
import debounce from "lodash/debounce";

// var breakpoints = (function() {
//   var breakpoint = utilities.getBreakpoint(window.innerWidth);

//   /**
//    * Respond to resize events
//    * @function resize
//    */
//   function resize() {
//     var newBreakpoint = utilities.getBreakpoint(window.innerWidth);
//     if(breakpoint === newBreakpoint) {
//       return;
//     }

//     breakpoint = newBreakpoint;

//     events.fire(document.body,'breakpointchange',breakpoint);
//   }

//   return {
//     resize: resize
//   };
// }());

var options = {
  debounce: {
    resize: 250,
    scroll: 5,
    scrollChange: 500,
  },
  scrollDirection: null,
  topScrollOffset: {
    previous: 0,
  },
};

/**
 * Update the stored 'previous' scroll offset to match the current offset
 * @function setPreviousScrollOffset
 * @private
 */
function setPreviousScrollOffset() {
  // Update the previous position with the current offset, ready for the next scroll movement
  options.topScrollOffset.previous = window.pageYOffset;
}

/**
 * Calculate which direction the scroll has been
 * @function init
 * @private
 */
function directionChange() {
  // Retrieve the previous and current scroll offsets, in order to work out the scroll direction
  var previous = options.topScrollOffset.previous;
  var current = window.pageYOffset;

  // Which direction is the user scrolling the page? (down or up)
  var direction = current > previous ? "down" : "up";

  // In the rare case where the previous and the current offsets match, return
  if (previous === current || current < 0) {
    return;
  }

  // Set a data attribute to identify which scroll direction has taken place
  document.body.setAttribute("data-scroll-direction", direction);
}

/**
 * Initialise the emitter
 * @function init
 */
export function init() {
  // Resize start
  window.addEventListener(
    "resize",
    debounce(
      function () {
        if (window.orientation === undefined) {
          // Add a processing class to the body as soon as resizing begins
          document.body.classList.add("processing");
        }

        events.fire(window, "resize.start");
      },
      options.debounce.resize,
      true
    )
  );

  // Resize stop
  window.addEventListener(
    "resize",
    debounce(function () {
      if (window.orientation === undefined) {
        // Remove a processing class from the body the moment resizing finishes
        document.body.classList.remove("processing");
      }

      events.fire(window, "resize.stop");
    }, options.debounce.resize)
  );

  // Scroll start
  window.addEventListener(
    "scroll",
    debounce(
      function () {
        events.fire(window, "scroll.start");
      },
      options.debounce.scroll,
      true
    )
  );

  // Scroll stop
  window.addEventListener(
    "scroll",
    debounce(function () {
      events.fire(window, "scroll.stop");
    }, options.debounce.scroll)
  );

  // Listen to the resize stop event
  // window.addEventListener('resize.stop',breakpoints.resize);

  // Custom event listener for when scrolling finishes (this is specifically used for the showing and hiding of the secondary navigation bar across all breakpoints)
  window.addEventListener(
    "scroll",
    debounce(function () {
      // Calculate which direction the scroll has been
      directionChange();

      // Update the stored 'previous' scroll offset to match the current offset
      setPreviousScrollOffset();
    }, options.debounce.scrollChange)
  );

  // Touchmove start
  window.addEventListener(
    "touchmove",
    debounce(
      function () {
        events.fire(window, "touchmove.start");
      },
      options.debounce.scroll,
      true
    )
  );

  // Touchmove stop
  window.addEventListener(
    "touchmove",
    debounce(function () {
      events.fire(window, "touchmove.stop");
    }, options.debounce.scroll)
  );

  // var domPromise = new Promise(function (resolve) {
  //   events.domReady(function (data) {
  //     resolve(data);
  //   });
  // });

  // // var dataLayerPromise = new Promise(function (resolve) {
  // //   events.listen(document.body, "dataLayer.ready", function (data) {
  // //     resolve(data);
  // //   });
  // // });

  // Promise.all([domPromise]).then(function () {
  //   events.fire(document.body, "tm.ready");
  //   events.fire(window, "analytics.mark", "tm.ready");
  // });

  // if (window.PerformanceObserver) {
  //   const observer = new window.PerformanceObserver((list) => {
  //     list.getEntries().forEach(({ name, startTime }) => {
  //       try {
  //         window.digitalData.page.info.timing[
  //           name.replace(/-([a-z])/gi, (name) => name[1].toUpperCase())
  //         ] = startTime;
  //       } catch (e) {
  //         // data layer not available
  //       }
  //     });
  //   });
  //   try {
  //     observer.observe({
  //       entryTypes: ["paint"],
  //     });
  //   } catch (e) {
  //     // doesn't support the paint entry type:(
  //   }
  // }
}
